import React from 'react';
import * as XLSX from 'xlsx';
import { RiDownload2Line } from 'react-icons/ri';
import { humanizeFieldName } from './formatters';

const MAX_RENDERED_ROWS = 200;

function displayCell(value) {
    if (value === null || value === undefined) return '–';
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value.toLocaleString(undefined, { maximumFractionDigits: 4 });
    }
    return String(value);
}

const ChatTable = ({ table }) => {
    const columns = Array.isArray(table && table.columns) ? table.columns : [];
    const rows = Array.isArray(table && table.rows) ? table.rows : [];
    const displayColumns = columns.map(humanizeFieldName);
    const rowCount = Number.isFinite(Number(table && table.row_count))
        ? Number(table.row_count)
        : rows.length;
    const visibleRows = rows.slice(0, MAX_RENDERED_ROWS);

    if (columns.length === 0) return null;

    const exportRows = () => {
        const worksheet = XLSX.utils.aoa_to_sheet([displayColumns, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'AI Query');
        XLSX.writeFile(workbook, `dataco-ai-query-${Date.now()}.xlsx`);
    };

    return (
        <section className="ai-chat-section">
            <div className="ai-chat-table-wrap">
                <table className="ai-chat-table">
                    <thead>
                        <tr>
                            {displayColumns.map((column, index) => (
                                <th key={`${columns[index]}-${index}`}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {visibleRows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columns.map((column, columnIndex) => (
                                    <td key={`${rowIndex}-${columnIndex}`}>
                                        {displayCell(Array.isArray(row) ? row[columnIndex] : undefined)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="ai-chat-table-footer">
                <span>
                    {rowCount > MAX_RENDERED_ROWS
                        ? `Showing ${MAX_RENDERED_ROWS} of ${rowCount.toLocaleString()} rows — export for the full set`
                        : `${rowCount.toLocaleString()} rows`}
                </span>
                <button type="button" onClick={exportRows}>
                    <RiDownload2Line /> Export XLSX
                </button>
            </div>
        </section>
    );
};

export default ChatTable;
